import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reviewTask } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { setDraftTask } from 'store/task';
import { useApplicationStore } from 'store/application';
import { taskKeys } from './queryKeys';

export const useTaskReviewQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return reviewTask(id);
    },

    onSuccess: (task) => {
      toast.success('Task has been sent for review successfully');
      setDraftTask({ task });
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
